import { WorkawareApi } from '../../apis/WorkawareApi'
import { TrackingModel } from '../models/TrackingModel'
import { transform, TransformMethods } from 'data/transform'
import { PagedResult } from "../../types/apis"

export class trackingService {
    private _api: WorkawareApi
    private _trackerTransform: TransformMethods<TrackingModel>
    constructor(api: WorkawareApi) {
        this._api = api
        this._trackerTransform = transform<TrackingModel>(TrackingModel)
    }
    // `filter` is an optional OData filter expression. Forwarded as-is to the API
    // client, which URL-encodes it. Callers should pass undefined (not "") when
    // no filter is active so the resulting URL has no `$filter` segment.
    get = (page: number, rowsPerPage: number, filter?: string) => new Promise<PagedResult<TrackingModel>>((resolve, reject) => {
        this._api.tracker.get(page, rowsPerPage, filter)
            .then(result => resolve({
                Count: result['@odata.count'] as number,
                Values: this._trackerTransform.arrayFrom(result.value)
            }))
            .catch(error => reject(error))
    })
    create = (data: TrackingModel) => new Promise<TrackingModel>((resolve, reject) => {
        this._api.tracker.post(data)
            .then(result => resolve(this._trackerTransform.from(result)))
            .catch(error => reject(error))
    })
    update = (Id: number, data: TrackingModel) => new Promise<TrackingModel>((resolve, reject) => {
        this._api.tracker.put(Id, data)
            .then(result => resolve(this._trackerTransform.from(result)))
            .catch(error => reject(error))
    })
    delete = (Id: number) => {
        return new Promise<any>((resolve, reject) => {
            this._api.tracker.delete(Id)
                .then(result => resolve(result))
                .catch(error => reject(error))
        })
    }
}